const url = "https://api.studio26.no/"
//const url = "http://localhost:3004/"
export default url
